/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import React from "react";

// import { NumberCell } from "../Number";

export const ORDER_DETAIL_BILLING_COLUMNS = [
  {
    Header: "Code",
    accessor: "Product.ProductCode",
    id: "ProductProductCode",
    Cell: ({ cell }) => cell?.value || "--"
  },
  {
    Header: "Description",
    accessor: "Description",
    id: "Description"
  },
  {
    Header: "Category",
    accessor: "Product.ProductCategory.CodeDescription",
    id: "ProductCategoryDescription"
  }
  // {
  //   Header: "Rate",
  //   accessor: "Rate",
  //   id: "Rate",
  //   Cell: ({ cell }) => <NumberCell value={cell.value} />
  // }
];

export const PRODUCT_DETAIL_BILLING_COLUMNS = orderDetails => [
  {
    Header: "Code",
    accessor: "Product.ProductCode",
    id: "ProductProductCode",
    Cell: ({ cell, row }) => (
      <p
        className={
          orderDetails.some(
            oProduct => oProduct.Product.RecId === row.original.Product.RecId
          )
            ? "equal"
            : "different"
        }
      >
        {cell.value}
      </p>
    )
  },
  {
    Header: "Description",
    accessor: "ProdDescription",
    id: "ProdDescription",
    Cell: ({ cell, row }) => (
      <p
        className={
          orderDetails.some(
            oProduct => oProduct.Product.RecId === row.original.Product.RecId
          )
            ? "equal"
            : "different"
        }
      >
        {cell.value}
      </p>
    )
  },
  {
    Header: "Category",
    accessor: "Product.ProductCategory.CodeDescription",
    id: "ProductCategoryDescription",
    Cell: ({ cell, row }) => (
      <p
        className={
          orderDetails.some(
            oProduct => oProduct.Product.RecId === row.original.Product.RecId
          )
            ? "equal"
            : "different"
        }
      >
        {cell.value}
      </p>
    )
  }
  // {
  //   Header: "Rate",
  //   accessor: "Rate",
  //   id: "Rate",
  //   Cell: ({ cell, row }) => (
  //     <NumberCell
  //       className={
  //         orderDetails.some(
  //           oProduct =>
  //             oProduct.Product.RecId === row.original.Product.RecId &&
  //             oProduct.Rate === row.original.Rate
  //         )
  //           ? "equal"
  //           : "different"
  //       }
  //       value={cell.value}
  //     />
  //   )
  // }
];
